/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_No_TargetInputs */

const en_tl_no_target = /** @type {(inputs: Tl_No_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No target date`)
};

const de_tl_no_target = /** @type {(inputs: Tl_No_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zieldatum`)
};

/**
* | output |
* | --- |
* | "No target date" |
*
* @param {Tl_No_TargetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_no_target = /** @type {((inputs?: Tl_No_TargetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_No_TargetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_no_target(inputs)
	return en_tl_no_target(inputs)
});